export default {
  101: "SIM ICCIDs are required to make an activate request. Please make sure you're passing in either a list of ICCIDs or a range of ICCIDs.",
  111: 'Invalid ICCID. Please check your ICCID number and try retyping.',
  112: 'A SIM range, with "start" and "end" ICCIDs, is required to make a bulk activate request.',
  113: 'Invalid ICCID due to missing "check digit". Please check your ICCID number and try retyping.',
} as const;
